export default "__VITE_ASSET__DNUnMBnD__"